import { About } from '../pages';
import Bookings from '../pages/Bookings';
import DropOff from '../pages/DropOff';
import Flight from '../pages/Flight';
import LoginPage from '../pages/Login';
import Operations from '../pages/operations';
import Pickup from '../pages/Pickup';
import Calendar from '../components/common/Calender';
import GlobalMapMobileApp from '../components/ui/GlobalMapMobileApp';
import PassengerManifest from '../pages/PassengerManifest';
import AvailabilityCalendar from '../components/common/MyAvailability';
import Compliances from '../pages/Compliances';


export const PATH_LOGIN = '/login';
export const PATH_ABOUT = '/about';
export const PATH_OPERATIONS = '/operations';
export const PATH_PICKUP = '/pickupAllocation';
export const PATH_DROPOFF = '/dropoffAllocation';
export const PATH_FLIGHT = '/flightAllocation';
export const PATH_BOOKINGS = '/bookings';
export const PATH_CALENDER = '/calendar';
export const PATH_GLOBAL_MAP = '/globalMap';
export const PATH_PASSENGER_MANIFEST = '/passengerManifest';
export const PATH_MY_AVAILABILITY = '/myAvailability';
export const PATH_COMPLIANCES = '/';

export const authenticatedRoutes = [
  { path: PATH_ABOUT, element: <About /> },
  { path: PATH_OPERATIONS, element: <Operations /> },
  { path: PATH_PICKUP, element: <Pickup /> },
  { path: PATH_DROPOFF, element: <DropOff /> },
  { path: PATH_FLIGHT, element: <Flight /> },
  { path: PATH_BOOKINGS, element: <Bookings /> },
  { path: PATH_CALENDER, element: <Calendar /> },
  { path: PATH_PASSENGER_MANIFEST, element: <PassengerManifest /> },
  { path: PATH_MY_AVAILABILITY, element: <AvailabilityCalendar /> },
  { path: PATH_COMPLIANCES, element: <Compliances /> },
];

export const unauthenticatedRoutes = [
  { path: PATH_LOGIN, element: <LoginPage /> },
];

export const publicRoutes = [
  { path: PATH_GLOBAL_MAP, element: <GlobalMapMobileApp /> },
];
